import { EstateAccountingQuebecDistribution } from '@/modules/estateaccountingquebecdistribution/models/EstateAccountingQuebecDistribution';
import { estateAccountingQuebecDistributions } from '@/modules/estateaccountingquebecdistribution/store/estateaccountingquebecdistribution.state';

export function setDistributions(value: EstateAccountingQuebecDistribution[]): void {
  estateAccountingQuebecDistributions.value = value;
}
